import { render } from "./Login.vue?vue&type=template&id=bf271520&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=bf271520&scoped=true&lang=css"

import exportComponent from "/home/luvenan/projects/get-it-done/get-it-done/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf271520"]])

export default __exports__